
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
    <div>
        <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
  <mat-toolbar *ngIf="!loading" class="d-flex justify-content-between mb-3">
    <mat-card-title>{{groupId ? 'Update Category' : 'Create Category'}}</mat-card-title>
      <button mat-flat-button color="error" aria-label="Cancel" (click)="openCancelDialog()">
        <fa-icon [icon]="faTimes"></fa-icon> 
      </button>
    </mat-toolbar>
    <div class="p-2 pb-5 h-100 w-100 relative scrollable">
    <app-group *ngIf="group" [group]="group"></app-group>
    </div>